import { fetchApiGraphQL, type GraphQLError } from "@/utils/fetcher";
import { createEnrichmentIsland } from "@/utils/islands";
import { showFormMessage } from "../formMessages";
import {verifyEmailMutation, VerifyEmailResult} from "@sitecorecomponents/Users/VerifyEmail/verifyemail.query";


function readToken(): string | null {
  return new URLSearchParams(document.location.search).get('token');
}

function hidePending(root: HTMLElement) {
  root.querySelectorAll<HTMLElement>('[data-verify-step="pending"]')
    .forEach(el => el.classList.add('hidden'));
}

function showStep(root: HTMLElement, step: 'success' | 'expired') {
  hidePending(root);

  root.querySelectorAll<HTMLElement>(`[data-verify-step="${step}"]`)
    .forEach(el => el.classList.replace('hidden', 'flex'));

  showFormMessage(root, null);
}

function showRequestFailed(root: HTMLElement) {
  hidePending(root);

  showFormMessage(root, 'request-failed');
}

function isTokenError(message: string): boolean {
  const text = message.toLowerCase();

  return text.includes('token') || text.includes('user not found');
}

async function verify(root: HTMLElement, token: string) {
  let result: VerifyEmailResult;
  try {
    result = await fetchApiGraphQL<VerifyEmailResult>(verifyEmailMutation, { token });
  } catch (err) {
    const message = (err as GraphQLError)?.errors?.[0]?.message ?? '';

    if (isTokenError(message)) {
      showStep(root, 'expired');
      return;
    }

    showRequestFailed(root);
    return;
  }

  if (!result?.data?.verifyEmail) {
    showStep(root, 'expired');
    return;
  }

  showStep(root, 'success');
}

export default function init() {
  createEnrichmentIsland('.verify-email', (root: Element) => {
    const token = readToken();
    if (!token) {
      showStep(root as HTMLElement, 'expired');
      return;
    }

    void verify(root as HTMLElement, token);
  });
}
